module.exports = __webpack_public_path__ + "media/images/icons/icon-shirt-be548ff7040994cdc2ebf633b71446b7.svg";